/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
export default function ownerDocument(node) {
  return node && node.ownerDocument || document;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-big-calendar/node_modules/dom-helpers/esm/ownerDocument.js
// module id = 139
// module chunks = 1